import React, {useState} from "react";
import {Button, Col, DatePicker, Flex, Form, Input, Result, Row, Space} from "antd";
import './../../styles/noweZgloszenie.css';
import Header from "./Header";
import NoweZgloszenieLayaut from "./NoweZgloszenieLayaut";
import {Card} from "react-bootstrap";
import dayjs from "dayjs";
import {addZgloszenie} from "./noweZgloszenieServices";
import {getFirmaLink, isEmpty} from "../../GlobalServices";
import Dropzone from "react-dropzone";
import {useNavigate} from "react-router-dom";
import type { GetProps } from 'antd';
import {
    InfoCircleOutlined,
} from '@ant-design/icons';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
type OTPProps = GetProps<typeof Input.OTP>;

const NoweZgloszenieForm = () => {
    const navigate = useNavigate();
    const [dodawanie, setDodawanie] = useState(false);
    const [dodano, setDodano] = useState(false);
    const [pliki, setPliki]: any = useState([]);
    const [numerZgloszenia, setNumerZgloszenia]: any = useState('');

    const onDrop = (files: any) => {
        let reader = new FileReader();
        reader.onload = () => {
            let result: any = reader.result
            let base64 = result.substr(result.indexOf(',') + 1, result.length - 1)
            setPliki(
                [...pliki,{
                    "dane": base64,
                    "dokumentTyp": "SYGNAL",
                    "dostep": "PUBLIC",
                    "nazwa": files[0].name,
                    "opis": "Plik do zgloszenia",
                    "rozmiar": files[0].size,
                    "slug": null,
                    "typ": files[0].type
                }]);
        };
        reader.readAsDataURL(files[0]);
    }

    const deletePlik = (item: any, index: number) => {
        // console.log(item.nazwa)
        // console.log(index)
        // let aktualnePliki = pliki;
        // aktualnePliki.splice(index, 1);
        // console.log('akt:', aktualnePliki);
        // console.log('akt:', aktualnePliki.length);
        // setPliki(aktualnePliki);

        setPliki(
            pliki.filter((p: any) =>
                p.nazwa !== item.nazwa
            )
        );
    }

    const onWyslijZgloszenie = (form: any) => {
        setDodawanie(true);
        // console.log(form);
        let dane = form;

        dane.data_od = isEmpty(form?.kiedy)? null : dayjs(form.kiedy[0]).format('YYYY-MM-DD');
        dane.data_do = isEmpty(form?.kiedy)? null : dayjs(form.kiedy[1]).format('YYYY-MM-DD');
        dane.status = 'nowe';
        dane.ctx_firma = getFirmaLink();
        delete dane.kiedy;

        dane = {
            sygnalAdd: dane,
            pliki: pliki
        }

        console.log(dane);

        addZgloszenie(dane).then((response) => {
            // console.log(response);
            setNumerZgloszenia(response.data);
            setDodawanie(false);
            setDodano(true);
        }).catch((error) => {
            console.log('error');
            setDodawanie(false);
            setDodano(false);
        })
    }

    const onClickNowe = () => {
        setDodano(false);
        setDodawanie(false);
        setPliki([]);
        setNumerZgloszenia('');
    }

    return (
        <NoweZgloszenieLayaut>

            {dodano ?
                <Result
                    status="success"
                    title="Zgłoszenie zostało poprawnie wysłane!"
                    subTitle="Uwaga! Zapisz i nie udostępniaj nikomu swojego numeru zgłoszenia oraz hasła."
                    extra={[
                        <h6 style={{marginBottom: '30px'}}>Twój numer zgłoszenia to: <label style={{color: '#0087fc', display: 'block', marginTop: '10px', marginBottom: '10px', fontWeight: 'bold'}}>{numerZgloszenia}</label><Button size={'small'} onClick={() => navigator.clipboard.writeText(String(numerZgloszenia))}>Kopiuj numer</Button></h6>,
                        <Button type="primary" key="mojeZgloszenie" onClick={() => navigate('/mojeZgloszenie')}>Moje zgłoszenie</Button>,
                        <Button key="nowe" onClick={onClickNowe}>Dodaj nowe</Button>,
                    ]}
                />
                :
                <div>
                    <h3 style={{marginTop: '15px'}}>Nowe zgłoszenie</h3>
                    <Card>
                        <Card.Body>
                            <Space direction="vertical" size="middle" style={{ display: 'flex', width: '100%' }}>
                                <Form
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    layout="vertical"
                                    onFinish={onWyslijZgloszenie}
                                    // style={{ maxWidth: 800 }}
                                >
                                    <Row gutter={16}>
                                        <Col xl={12}>
                                            <Form.Item label="Miejsce zdarzenia" name={'miejsce'} wrapperCol={{span: 12}}>
                                                <Input maxLength={100} />
                                            </Form.Item>
                                            <Form.Item label="Kiedy doszło do incydentu?" name={'kiedy'} wrapperCol={{span: 12}}>
                                                <RangePicker />
                                            </Form.Item>
                                            <Form.Item label="Kogo dotyczy zgłoszenie?" name={'kogo_dotyczy'} wrapperCol={{span: 12}}>
                                                <Input maxLength={100}/>
                                            </Form.Item>
                                            <Form.Item label="Opisz dokładnie całą sytuację:" name={'opis'} rules={[{ required: true, message: 'Pole wymagane' }]} wrapperCol={{span: 24}}>
                                                <TextArea rows={8} maxLength={5000} style={{width: '100%'}}/>
                                            </Form.Item>
                                            <Form.Item label="Dokumentacja" wrapperCol={{span: 24}}>
                                                <Dropzone onDrop={onDrop}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section>
                                                            <div {...getRootProps()} className={'dropzone-field'}>
                                                                <input {...getInputProps()} />
                                                                <p>Przeciągnij tutaj lub kliknij by dodać plik</p>
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                                {pliki.length > 0 && <div style={{paddingTop: '15px', paddingBottom: '5px'}}>
                                                    {pliki.map((item: any, index: number) => {
                                                        return <div key={index}><i
                                                            className={'fa fa-file'}/> {item.nazwa} ({parseFloat(item.rozmiar) / 1000} kb)<i
                                                            className={'fa fa-times'}
                                                            style={{color: '#ff4444', cursor: 'pointer'}}
                                                            onClick={() => deletePlik(item, index)}/> </div>
                                                    })}</div>}
                                            </Form.Item>
                                        </Col>
                                        <Col xl={12}>
                                            <p style={{fontWeight: 'bold', marginBottom: 0}}>Dane kontaktowe osoby zgłaszającej</p>
                                            <p>Jeśli chcesz pozostać anonimowy, nie musisz uzupełniać.</p>
                                            <Form.Item label="Imię" name={'imie'} wrapperCol={{span: 12}}>
                                                <Input maxLength={100} />
                                            </Form.Item>
                                            <Form.Item label="Nazwisko" name={'nazwisko'} wrapperCol={{span: 12}}>
                                                <Input maxLength={100} />
                                            </Form.Item>
                                            {/*<Form.Item label="Miejscowość" wrapperCol={{span: 12}}>*/}
                                            {/*    <Input />*/}
                                            {/*</Form.Item>*/}
                                            {/*<Form.Item label="Ulica" wrapperCol={{span: 12}}>*/}
                                            {/*    <Input />*/}
                                            {/*</Form.Item>*/}
                                            <Form.Item label="E-mail" name="email">
                                                <Input maxLength={100} />
                                            </Form.Item>

                                            <h6 style={{textAlign: 'center', marginTop: '35px'}}>Zdefiniuj PIN</h6>
                                            <Form.Item label="Podaj hasło, za pomocą którego będziesz mógł później odszuać swoje zgłoszenie." name={'pin'} rules={[{ required: true, message: 'Pole wymagane' }]}>
                                                <Input maxLength={10} showCount />
                                            </Form.Item>
                                            <p style={{color: '#4f4f4f', fontSize: 'small'}}><InfoCircleOutlined/> max 10 znaków</p>

                                            {/*<Form.Item label="Success" validateStatus="success" name={'pin'} rules={[{ required: true, len: 4, message: 'Pole wymagane' }]}>*/}
                                            {/*    <Input.OTP length={4} mask={'*'}/>*/}
                                            {/*</Form.Item>*/}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit" loading={dodawanie} disabled={dodawanie}>
                                                    Wyślij zgłoszenie
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                </Form>
                            </Space>
                        </Card.Body>
                    </Card>
                </div>
            }

        </NoweZgloszenieLayaut>
    )
}

export default NoweZgloszenieForm;
